import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import EmployeeFile from 'module/staff-management/pages/EmployeeFile'

const StaffManagement = ({ initialTab }) => {
  const [tabIndex] = useState(0)
  const navigate = useNavigate()

  const changeRoute = (index) => {
    switch (index) {
      case 0:
        navigate('/app/management-centre/staff-management/employee-file')
        break
      case 1:
        navigate('/app/management-centre/staff-management/organization-chart')
        break
      default:
        break
    }
  }

  useEffect(() => {
    changeRoute(tabIndex)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabIndex])

  return (
    <DashboardContainer headerTitle="Staff Management">
      <EmployeeFile />
    </DashboardContainer>
  )
}

export default StaffManagement
